export function sortArrayBySequence<T>(arr: T[]) {
  if(!arr)
  return []
  return arr.sort((a: any, b: any) => a.sequence - b.sequence);
}
